"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalVariantMargin = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineMargin_1 = require("./getOrderLineMargin");
const getTotalVariantMargin = (variant) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return variant.order_lines.reduce((acc, cur) => {
        if (!cur.versions)
            return acc;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(cur.versions);
        if (!latest_version)
            return acc;
        const config = latest_version.config;
        return acc + (0, getOrderLineMargin_1.getOrderLineMargin)(config, cur.type);
    }, 0);
};
exports.getTotalVariantMargin = getTotalVariantMargin;
